/**
 * Created by daniel on 02/05/17.
 */

import React, {Component} from 'react';
import {Dialog, RaisedButton, Tab, Tabs, TextField} from "material-ui";
import "./ExportDialog.css"

class ExportDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      importJson: "",
    };
    this.handleOnClick = this.handleOnClick.bind(this);
  }
  
  handleOnClick(e) {
    if ( document.selection ) {
      let range = document.body.createTextRange();
      range.moveToElementText( e.currentTarget );
      range.select();
    } else if ( window.getSelection ) {
      let range = document.createRange();
      range.selectNodeContents( e.currentTarget );
      window.getSelection().removeAllRanges();
      window.getSelection().addRange( range );
    }
  };
  
  render() {   
    let importable;
    let importMessage;
    try {
      JSON.parse(this.state.importJson);
      importable = true;
      importMessage = "Click to import this saved template";
    } catch (e) {
      importable = false;
      importMessage = "Import text error:\n" + e.message;
    }
    let html = "";
    
    if (this.props.open) {
      html = this.props.getHtml();
    }
    
    return (
      <Dialog
        open={this.props.open}
        actions={
          <RaisedButton
            label="Done"
            onTouchTap={() => this.props.visibility(false)}
          />
        }
        title="Import and export"
      >
        <Tabs
          contentContainerStyle={{
            maxHeight: "50vh",
            padding: "20px",
            overflowY: "auto"
          }}
        >
          <Tab label="Export HTML" >
            Warnings:
            <div
              className="code-lines"
            >
              {this.props.open && html.warnings ? html.warnings.split("\n").map((item, index) => [<code key={index}>{item}</code>, <br/>]) : <code>None</code>}
              
            </div>
            Processed:
            <div
              className="code-lines"
              onClick={this.handleOnClick}
            >
              {this.props.open && html.inlined.split("\n").map((item, index) => [<code key={index}>{item}</code>, <br/>])}
            </div>
            Original:
            <div
              className="code-lines"
              onClick={this.handleOnClick}
            >
              {this.props.open && html.original.split("\n").map((item, index) => [<code key={index}>{item}</code>, <br/>])}
            </div>
          </Tab>
          <Tab label="Export Template JSON">
            This can be loaded into a different editor instance.
            <div
              className="code-lines"
              onClick={this.handleOnClick}
            >
              {this.props.open && JSON.stringify(this.props.currentState,null,'  ').split("\n").map((item, index) => [<code key={index}>{item}</code>, <br/>])}
            </div>
          </Tab>
          <Tab label="Import Template JSON">
            <TextField
              hintText="Paste JSON here"
              floatingLabelText="Paste JSON here"
              multiLine={true}
              value={this.state.importJson}
              fullWidth={true}
              onChange={(e, val) => this.setState({importJson: val})}
            />
            <p style={{color: importable ? "green" : "red"}}>{importMessage}</p>
            <RaisedButton
              label="Import"
              disabled={!importable}
              onTouchTap={() => this.props.importContent(JSON.parse(this.state.importJson))}
            />
          </Tab>
        </Tabs>
      </Dialog>
    );
  }
}

export default ExportDialog;


// WEBPACK FOOTER //
// ./src/App/Editor/components/ui/ExportDialog.js